import SelectClass from 'template/Modals/EnrollClass';

export default function enrollStudentToClass(students, cb) {
  SelectClass({ students })
    .then(({ updateRequired: updateStudentTableRequired })=>{
      if (updateStudentTableRequired) {
        let { 
          studentState, 
          student 
        } = this.props;
       
        student.fetchStudent('After editing classes @enroll-student-to-class', studentState);
      }  
    })
    .catch((err)=>{
      console.error(err);
    });


} 



// WEBPACK FOOTER //
// ./src/containers/pages/Student/enroll-student-to-class.js